module.exports = __webpack_public_path__ + "static/media/image_1.65d38c41.jpg";